import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Head from '../../../layout/head/Head';
import * as app_consts from "../../../utils/app_consts";
import Content from '../../../layout/content/Content';
import TablePageHeading from '../../components/page_heading/TablePageHeading';
import CardTabs from '../../components/cards/CardTabs';
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../error/AuthTenantPageError';
import TableList from '../../components/table/TableList';
import { RETRIEVE_TENANT_WAREHOUSE_SITES_API } from '../../../api/api_data';
import { fail_retrieve_warehouse_sites, loading_retrieve_warehouse_sites, reset_retrieve_warehouse_sites, success_retrieve_warehouse_sites } from '../../../reducers/auth_tenant/retrieve_warehouse_sites_Slice';
import { RETIREVE_WAREHOUSE_SITES_ERROR_MSG, RETIREVE_WAREHOUSE_SITES_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { messageToast } from '../../../utils/Utils';
import { useSelector } from 'react-redux';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import AddWarehouseSiteModal from '../../components/modal/AddWarehouseSiteModal';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../../components/Component';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Badge } from 'reactstrap';
import AuthTenantNoData from '../../error/AuthTenantNoData';

const WarehouseSites = ({ tenant_info, user_info }) => {

  // 
  const [virtual_warehouses, setVirtualWarehouse] = useState([]);
  const [physical_warehouses, setPhysicalWarehouses] = useState([]);
  const [page_data, setPageData] = useState([]);
  const [current_page_data, setCurrentPageData] = useState([]);
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [activeCardTab, setActiveCardTab] = useState("Physical Warehouse Sites");
  const [add_warehouse_site_modal, setWarehouseSiteModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [sm, updateSm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // First COde to Run
  useEffect(() => {
    retrieve_warehouse_sites();
  }, []);

  const retrieve_warehouse_sites = () => {
    setError("");
    setLoading(true);
    dispatch(tenant_auth_actions_helper(loading_retrieve_warehouse_sites, success_retrieve_warehouse_sites, fail_retrieve_warehouse_sites, RETIREVE_WAREHOUSE_SITES_ERROR_MSG, RETIREVE_WAREHOUSE_SITES_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_WAREHOUSE_SITES_API}`));
  };
  // Listen
  const retrieve_warehouse_sites_listener = useSelector((state) => state.retrieve_warehouse_sites.retrieve_warehouse_sites);

  useEffect(() => {
    if (retrieve_warehouse_sites_listener.status !== app_consts.IDLE)
    {
      if (retrieve_warehouse_sites_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_warehouse_sites_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_warehouse_sites_listener.message, app_consts.FAIL);
          messageToast(retrieve_warehouse_sites_listener.message, app_consts.FAIL);
        } else if (retrieve_warehouse_sites_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_warehouse_sites_listener.data);
          setCurrentPageData(retrieve_warehouse_sites_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_warehouse_sites());
      }
    }
  }, [retrieve_warehouse_sites_listener]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate the start and end index for the current page
  const startIndex = (currentPage - 1) * itemPerPage;
  const endIndex = startIndex + itemPerPage;

  // UseEffect for Search 
  useEffect(() => {
    filtered_warehouse_sites(searchTerm);
  }, [searchTerm]);

  const filtered_warehouse_sites = (searchItem) => {
    if (searchItem)
    {
      let displayedWarehouseSites;

      displayedWarehouseSites = page_data?.filter((item) => {
        const combinedParams = [
          item?.name,
          item?.address,
          item?.district,
          item?.province,
          item?.account?.email_address,
          item.department,
          item.country,
          item.status?.replace(/_/g, ' ').toUpperCase(),
        ]
          .join(" ")
          .toLowerCase();

        return combinedParams.includes(searchItem.toLowerCase());
      }).slice(startIndex, endIndex);

      setCurrentPageData(displayedWarehouseSites);
    } else
    {
      setCurrentPageData(page_data);
    }
  };

  // Card Tabs
  const tabs = [
    {
      tabName: "Physical Warehouse Sites"
    },
    {
      tabName: "Virtual Warehouse Sites"
    },
  ];

  const openAddListModal = () => {
    setWarehouseSiteModal(true);
  };

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = current_page_data?.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Warehouse Sites` : " Warehouse Sites"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Warehouse Sites</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(loading || error) && `Warehouse Sites ${current_page_data?.length}`}</p>
              </BlockDes>
              {!(loading) && (
                <div className="mt-2">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      retrieve_warehouse_sites();
                    }}
                  >
                    <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </div>
              )}
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand me-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    updateSm(!sm);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          id="default-04"
                          value={searchTerm}
                          onChange={e => setSearchTerm(e.target.value)}
                          placeholder="Search for Warehouse Sites"
                        />
                      </div>
                    </li>
                    {
                      (user_info?.roles?.includes(app_consts.ADMINISTRATOR) || user_info?.roles?.includes(app_consts.ADD_WAREHOUSE_SITE)) && (
                        <>
                          <li className="nk-block-tools-opt">
                            <Button
                              className="toggle btn-icon d-md-none"
                              color="primary"
                              onClick={() => {
                                openAddListModal();
                              }}
                            >
                              <Icon name="plus"></Icon>
                            </Button>
                            <Button
                              className="toggle d-none d-md-inline-flex"
                              color="primary"
                              onClick={() => {
                                openAddListModal();
                              }}
                            >
                              <Icon name="plus"></Icon>
                              <span>Add Warehouse Sites</span>
                            </Button>
                          </li>
                        </>
                      )
                    }
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Warehouse Sites..." />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      page_data && page_data?.length > 0 ?
                        <>
                          <Block>
                            <div className="nk-tb-list is-separate is-medium mb-3">
                              <DataTableHead className="nk-tb-item">
                                <DataTableRow>
                                  <span className="sub-text">Name</span>
                                </DataTableRow>
                                <DataTableRow size="mb">
                                  <span className="sub-text">Type</span>
                                </DataTableRow>
                                <DataTableRow size="mb">
                                  <span className="sub-text">Address</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">District</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Province</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Country</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Status</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Action</span>
                                </DataTableRow>
                              </DataTableHead>
                              {/*Head*/}
                              {currentItems.length > 0
                                ? currentItems.map((item) => (
                                  <DataTableItem key={item.id}>
                                    <DataTableRow>
                                      <Link to={`/${tenant_info.url_prefix}/employees/${item?.account?.mobile_number}`}>
                                        <div className="user-card">
                                          <div className="user-info">
                                            <span className="tb-lead">
                                              {
                                                item?.name
                                                  ? item?.name?.length > 30
                                                    ? `${item?.name?.substring(0, 30)}...`
                                                    : item?.name
                                                  : ""
                                              }<span className="dot dot-success d-md-none ms-1"></span>
                                            </span>
                                          </div>
                                        </div>
                                      </Link>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.type?.toUpperCase() || "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.address || "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.district || "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.province || "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.country || "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <span className="tb-odr-status">
                                        <Badge
                                          color={
                                            item?.status === app_consts.ACTIVE
                                              ? "success"
                                              : "warning"
                                          }
                                          className="badge-dot"
                                        >
                                          {item?.status?.toUpperCase() || "--"}
                                        </Badge>
                                      </span>
                                    </DataTableRow>
                                    <DataTableRow className="nk-tb-col-tools">
                                      <div className="tb-odr-btns d-none d-sm-inline">
                                        <Link /* to={`/${tenant_info.url_prefix}/employees/${item?.account?.mobile_number}`} */>
                                          <Button color="primary" size="sm" className="btn btn-dim">
                                            View
                                          </Button>
                                        </Link>
                                      </div>
                                      <Button className="btn-pd-auto d-sm-none">
                                        <Icon name="chevron-right"></Icon>
                                      </Button>
                                    </DataTableRow>
                                  </DataTableItem>
                                ))
                                : null}
                            </div>
                            {currentItems?.length > 0 && (
                              <div className="mt-3">
                                <PaginationComponent
                                  itemPerPage={itemPerPage}
                                  totalItems={current_page_data?.length}
                                  paginate={paginate}
                                  currentPage={currentPage}
                                />
                              </div>
                            )}
                          </Block>
                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Warehouse Sites Found"} />
                        </>
                    }
                  </>
              }
            </>
        }
      </Content>
      <AddWarehouseSiteModal openModal={add_warehouse_site_modal} setOpenModal={setWarehouseSiteModal} modalTitle="Add Warehouse Site" succFunc={retrieve_warehouse_sites} tenant_info={tenant_info} />
    </>
  );
};

export default WarehouseSites;